import React from 'react';
import { NavigationPaths } from '../constants';
import {
  Confirmation,
  Login,
  NewPassword,
  NotFound,
  Organization,
  ResetPassword,
} from '../containers';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
  isPrivate?: boolean;
  restrictedPaths?: NavigationPaths[];
}

export const routesConfig: RouteConfig[] = [
  { path: NavigationPaths.LOGIN, element: <Login /> },
  { path: NavigationPaths.RESET_PASSWORD, element: <ResetPassword /> },
  { path: NavigationPaths.NEW_PASSWORD, element: <NewPassword /> },
  { path: NavigationPaths.CONFIRMATION, element: <Confirmation /> },
  { path: NavigationPaths.ORGANISATION_USERS, element: <Organization />, isPrivate: true },
  { path: NavigationPaths.NOT_FOUND, isPrivate: true, element: <NotFound /> },
  { path: '/', element: <Login /> },
];
